"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const openRoles = [{
  id: "licensed-clinician",
  title: "Licensed Clinician (LMHC/LCSW)",
  description: "Join our group practice in Massachusetts as a primary therapist. We provide a steady stream of clients, full administrative billing support, and a collaborative environment where your clinical autonomy is respected and celebrated."
}, {
  id: "associate-clinician",
  title: "Associate Clinician (Pre-licensed)",
  description: "Earn your hours in a supportive 'garden' environment. We provide weekly individual and group supervision, clinical training stipends, and a clear pathway to your independent licensure within our restorative practice."
}, {
  id: "clinical-supervisor",
  title: "Senior Clinical Supervisor",
  description: "Mentor the next generation of therapists while maintaining a specialized private caseload. Shape our clinical philosophy and ensure the highest standards of evidence-based care for our community through dedicated guidance."
}, {
  id: "operations-lead",
  title: "Operations & Intake Lead",
  description: "Manage the heartbeat of our practice. From initial client intake to matching patients with the right therapist, you ensure the administrative side of healing flows seamlessly and with compassionate precision."
}];
export default function JoinThePlatform() {
  const {
    ref: leftRef,
    isVisible: leftIsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightIsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}